module.exports = __webpack_public_path__ + "static/media/bluefarms_logo.873d1e42.svg";